<template>
  <div
    class="gauge"
    :style="{ backgroundColor }"
  >
    <div
      class="inner-gauge"
      :style="{ width: `${percent}%` }"
    />
  </div>
</template>

<script setup lang="ts">
withDefaults(
  defineProps<{
    percent?: number
    backgroundColor?: string
  }>(),
  {
    percent: 0,
    backgroundColor: '#0d3969',
  },
)
</script>

<style lang="scss" scoped>
.gauge {
  position: relative;
  width: 100%;
  height: 1rem;
  border-radius: 0.5rem;

  .inner-gauge {
    position: absolute;
    top: 0;
    left: 0;
    width: 0;
    height: 100%;
    background-color: $blue;
    background-image: linear-gradient(to right, $blue, #15a3d8);
    border-radius: 0.5rem;
  }
}
</style>
